import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: 'rgb(231, 238, 237)',
    padding: '1rem',
    borderRadius: '8px',
  },
}));
